module.exports = __webpack_public_path__ + "media/img/pages/companies/smn-712ca7ec6b69615546e271101bd93383.jpg";